import DeleteModifiersModal from './DeleteModifiersModal';
import ModifierModal from './ModifierModal';

export default {
  DeleteModifiersModal,
  ModifierModal,
};
